import { ContactPageTypes,  MetaTagsProps} from "@/types";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";

export const metaTagsContact : MetaTagsProps = {
    title: `Contact Us - ${BUSINESS_NAME}`,
    description: `Contact ${BUSINESS_NAME}, Sydney’s trusted excavation specialists for residential, commercial, and industrial projects. Get in touch for site cuts, footings, trenching, pool demolition, soil removal and more.`,
    keywords: "contact excavation sydney, excavation company contact, excavation quotes sydney, site cuts contact, trenching and footings sydney",
    url: `${WEBSITE_URL}/contact`,
ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const contactPageContent : ContactPageTypes = {
    title: 'Contact Us',
    description: 'Get in touch with Harris Excavation Services today. Whether you need residential excavation, commercial site preparation, or equipment hire, our Sydney-based team is ready to assist with reliable service and competitive quotes.',
    images: [],
}


